const summariesFactor = require('../../common/summariesFactor');

module.exports = function (sheet, previous) {
  return {
    totals: previous.totals,
    summaries: summariesFactor(previous.summaries),
    notices: previous.notices
  }
};